class LjReportApi {

    // Paged list of stocks-with-sales for the LJ Reports picker.
    // params mirrors the shape used by stockApi.getList.
    getList({
        page = 1,
        itemsPerPage = 10,
        sorter = null,
        filters = {},
        search = ''
    } = {}) {
        let url = apiUrl + 'ljreports';
        const qs = [];
        qs.push('page=' + encodeURIComponent(page));
        qs.push('itemsPerPage=' + encodeURIComponent(itemsPerPage));
        if (sorter && sorter.column) {
            qs.push('sortColumn=' + encodeURIComponent(sorter.column));
            qs.push('sortAsc=' + (sorter.asc ? 'true' : 'false'));
        }
        if (search) qs.push('search=' + encodeURIComponent(search));
        if (filters) {
            for (const k of Object.keys(filters)) {
                if (filters[k] !== '' && filters[k] != null) {
                    qs.push('filters[' + encodeURIComponent(k) + ']=' + encodeURIComponent(filters[k]));
                }
            }
        }
        url += '?' + qs.join('&');
        // AutoWrapper response: { version, message, result: {...} } — unwrap.
        return api.call('get', url).then(({ data }) => (data && data.result) ? data.result : data);
    }

    // Full joined LJ report for one Stock — auto-creates the empty
    // LjReport row on first access.
    get(stockId) {
        const url = apiUrl + 'ljreports/' + stockId;
        return api.call('get', url).then(({ data }) => (data && data.result) ? data.result : data);
    }

    // Upsert LJ report + replace MiscCosts/Discounts wholesale.
    save(stockId, data) {
        const url = apiUrl + 'ljreports/' + stockId;
        return api.call('put', url, data).then(({ data }) => (data && data.result) ? data.result : data);
    }
}

export default LjReportApi;
